module.exports = __webpack_public_path__ + "static/img/viva.ee17a4a0.jpg";